<template>
  <NebulaButton
    :aria-label="$t('Open larger view')"
    class="zoom-button"
    icon-left="zoom-in"
    shape="pill"
    type="flat"
    size="m"
    @click="$emit('click', $event)"
  />
</template>

<script>
import { NebulaButton } from '@discoveryedu/nebula-components';

export default {
  components: {
    NebulaButton,
  },
  emits: ['click'],
};
</script>

<style lang="stylus">
.zoom-button {
  background-color: rgba($nebula-color-black, .35);

  &:hover, &:focus {
    background-color: rgba($nebula-color-black, .45);
  }

  &:active {
    background-color: rgba($nebula-color-black, .55);
  }

  svg.nebula-button__icon {
    fill: $nebula-color-white;
  }
}
</style>
